import Footer from "./Footer";
import Header from "./Header";
const Pythonwebdevelopment = () => {
  return (
    <div className="container-fuild">
      <Header />
      <div className="container">
        <div className="row border border-dark m-1">
          <div className="row text-center m-3">
            <h1>
              <b>
                <u>Python Web Development</u>
              </b>
            </h1>
          </div>

          <div className="row m-3"></div>

          <div className="row m-5 h4">
            <fieldset>
              <legend style={{ width: "40%" }}>Topics:</legend>
              <div className="card">
                <div className="card-header">
                  <a
                    className="btn"
                    data-bs-toggle="collapse"
                    href="#collapse1">
                    Python Term 1:(Foundation Programming in Python Web
                    Development)
                  </a>
                </div>
                <div
                  id="collapse1"
                  className="collapse"
                  data-bs-parent="#accordion">
                  <div className="card-body">
                    <ul>
                      <li>
                        <a href="/syllabus/html.html">HTML</a>
                      </li>
                      <li>
                        <a href="/syllabus/python.html">Core Python</a>
                      </li>
                      <li>
                        <a href="/syllabus/mysql.html">My SQL</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <a
                    className="btn"
                    data-bs-toggle="collapse"
                    href="#collapse1">
                    Python Term 2: (Python Web Developer)
                  </a>
                </div>
                <div
                  id="collapse1"
                  className="collapse"
                  data-bs-parent="#accordion">
                  <div className="card-body">
                    <ul>
                      <li>
                        <a href="/syllabus/flask.html">Flask</a>
                      </li>
                      <li>
                        <a href="/syllabus/django.html">Django</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <a
                    className="btn"
                    data-bs-toggle="collapse"
                    href="#collapse1">
                    Python Term 3: (Advanced Programming in Python Web
                    Development)
                  </a>
                </div>
                <div
                  id="collapse1"
                  className="collapse"
                  data-bs-parent="#accordion">
                  <div className="card-body">
                    <ul>
                      <li>
                        <a href="/syllabus/mongodb.html">Mongo DB</a>
                      </li>
                      <li>
                        <a href="/syllabus/reactjs.html">React Js</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div className="row m-5">
            <h2>
              <b> Certificate:</b>
            </h2>
            <h2>
              <p>Python Web Development</p>
            </h2>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Pythonwebdevelopment;
